module.exports = __webpack_public_path__ + "img/image02_sp.f4152a9c.jpg";